<template>
    <div>
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'secretaria-de-hacienda'"></boton-atras>
            <div class="descripcion">
                <h6 class="subtitulo mb-2">Misión</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <h5 class="cuerpo_descripcion">
                    Procurar la administración del ingreso, de los recursos humanos y del desarrollo administrativo, así como la asignación prioritaria del presupuesto de egresos, el financiamiento público, el control de las entidades paraestatales y la planeación del desarrollo del Estado; enfocado en un ejercicio de rendición de cuentas claras y transparentes e innovando a través de leyes, sistemas y políticas; que permita ofrecer servicios de calidad a los contribuyentes, organismos públicos, federación y municipios.
                </h5>
            </div>
            <div class="descripcion">
                <h6 class="subtitulo mb-2">Visión</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <h5 class="cuerpo_descripcion">
                   Ser la Dependencia líder, que garantice la credibilidad, transparencia y confianza en las finanzas públicas y en la planeación del Estado, asegurando el equilibrio financiero y la administración innovadora y eficaz de la Finanza pública, para propiciar certidumbre social, desarrollo y crecimiento económico, así como la gobernabilidad en la entidad.
                </h5>
            </div>
         </div>
    </div>
</template>
<script>
import atrasComponent from './../../reload'
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        atrasComponent,
        botonAtras,
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>
